import React from 'react';
import { Typography } from 'fronton-react';
import { root } from './style';

type Props = {
  label: string;
  timeRange: string;
};

export const OperationalTime: React.FC<Props> = React.memo(({ label, timeRange }) => (
  <div className={root}>
    <Typography variant="s" size="body_short" color="text-primary">
      {label}
    </Typography>
    <Typography variant="s" size="body_short" color="text-primary">
      {timeRange}
    </Typography>
  </div>
));
